import * as React from 'react';

export interface IConsoleLineProps {
  style?: any;
}

export const ConsoleRunning: React.StatelessComponent<IConsoleLineProps> =
({style}: IConsoleLineProps) => (
  <div className={`console-component--line-system`} style={style}>
    {'Executing code...'}
  </div>
);
